'use client';

import { useState, useEffect } from 'react';
import { useHasHydrated } from '@/hooks/general/useHasHydrated';
import { useAuthStore } from '@/store/authStore/authStore';

export function useHydratedAuthState() {
    const hasHydrated = useHasHydrated();

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const { loggedIn } = useAuthStore((state) => ({
        loggedIn: state.loggedIn,
    }));

    useEffect(() => {
        if (hasHydrated) {
            setIsLoggedIn(loggedIn);
        }
    }, [hasHydrated, loggedIn]);

    return {
        isLoggedIn: hasHydrated ? isLoggedIn : false,
        hasHydrated,
    };
}
